exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-691a398b] {\n  margin-top: 270px;\n}\n.content-tlist[data-v-691a398b] {\n  border: none;\n}", ""]);

// exports
